import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import numeral from 'numeral'

import styles from './styles.module.scss'

import { getCurrency } from '../../../../helpers/currencies'

const formatNumber = (value, currency) => {
  return `${numeral(value).format('0,0.[00]')} ${currency}`
}

const RevenueByWarehouse = ({transactions}) => {
  const { t } = useTranslation()
      
  const companyInfo = useSelector(state => state.company.companyInfo)
  const currency = getCurrency(companyInfo?.currency)

  const data = useMemo(() => {
    const invoices = transactions.filter(tr => tr.TransactionType === 'INVOICE')
    const warehouseMap = invoices.reduce((acc, transaction) => {
      const warehouse = transaction['Account.Name'] || 'Uncategorized'
      return {
        ...acc,
        [warehouse]: acc[warehouse] ? [...acc[warehouse], transaction] : [transaction],
      }
    }, {})

    const totalAmount = invoices.reduce((acc, transaction) => acc + (transaction['Sum.Incoming'] || 0), 0)

    return Object.entries(warehouseMap).map(([warehouse, transactions]) => {
      const amount = transactions.reduce((acc, transaction) => acc + (transaction['Sum.Incoming'] || 0), 0)
      return {
        name: warehouse,
        amount: transactions.reduce((acc, transaction) => acc + (transaction['Sum.Incoming'] || 0), 0),
        percentage: totalAmount > 0 ? (amount / totalAmount * 100) : 0,
      }
    })
  }, [transactions])

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.title}>{t('Revenue by warehouse')}</div>
      </div>
      {
        data.map((item, i) => {
          return (
            <div key={i} className={styles.paymentMethodItem}>
              <div className={styles.paymentMethodHeader}>
                <div>{item.name}</div>
                <div>{formatNumber(item.amount, currency.symbol)} · {numeral(item.percentage).format('0.0')}%</div>
              </div>
              <div className={styles.progress}>
                <div className={styles.progressBar} style={{width: `${item.percentage}%`}}></div>
              </div>
            </div>
          )
        })
      }
    </div>
  )
}

export default RevenueByWarehouse
